import { useTranslation } from 'react-i18next';

import { DataStatus } from '@features/users/adminPanel/components/DataStatus/DataStatus.tsx';
import { Advertiser } from '@features/users/adminPanel/types/advertisers.types.ts';
import { Icon } from '@shared/components/Icon/Icon.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './Header.module.scss';

type HeaderProps = Omit<Advertiser, 'invoicingEmail' | 'id'>;
export function Header({ name, status, vatNumber }: HeaderProps) {
  const { t } = useTranslation(i18nNameSpace.USERS);

  const statusTranslationKey = status.toLowerCase();

  return (
    <header className={styles.wrapper}>
      <div className={styles.nameWrapper}>
        <Icon iconAltText={'Advertiser'} variant={'bag'} />
        <h2 className={styles.header}>
          <span className={styles.name}>{name || '- '}</span>
          <span className={styles.subName}>{vatNumber}</span>
        </h2>
      </div>
      <div>
        <DataStatus
          variant={status}
          textLabel={t(`page.adminPanel.dataStatus.${statusTranslationKey}`)}
          textLabelClassName={styles.statusTextLabel}
        />
      </div>
    </header>
  );
}
